import React, { Component } from 'react';
import { SearchField } from '../../../../common'
import { searchBarStyle } from './style';
import { WithStyles, withStyles } from '@material-ui/core';

interface SearchBarProps extends WithStyles<typeof searchBarStyle> {
    classes: any,
    handlePageChange?: Function,
    handleIsSearchQueryTouched: Function,
}
interface SearchBarState {
    searchQuery: string
}
class SearchBar extends Component<SearchBarProps, SearchBarState>{
    constructor(props: SearchBarProps) {
        super(props);
        this.state = {
            searchQuery: '',
        }
    }
    handleTextChange = (event: any) => {
        this.setState({
            searchQuery: event.target.value
        },()=>{
            const { searchQuery } = this.state;
            const { handleIsSearchQueryTouched } =this.props;
            if(searchQuery){
                handleIsSearchQueryTouched(true);
            }else{
                handleIsSearchQueryTouched(false);
            }
            this.handleSearchQuery(searchQuery);
        })
        
    }

    handleSearchQuery = (text ?:string) =>{
        const { handlePageChange } = this.props;
        const { searchQuery = '' } = this.state;
        text ? handlePageChange && handlePageChange({ searchQuery :text }) : handlePageChange && handlePageChange({ searchQuery })
    }
    
    renderSearchBar = () => {
        const { classes, handlePageChange } = this.props;
        const { searchQuery = '' } = this.state;
        return (
            <div className={classes.tabsContainer2}>
                <SearchField
                    name="search"
                    label="Search phase Template"
                    value={searchQuery}
                    onKeyPress={(event: any) => {
                        if (event.key === 'Enter') {
                            this.handleSearchQuery()
                        }
                      }}
                    onFocus={() => { }}
                    onChange={this.handleTextChange}
                    onBlur={() => { this.handleSearchQuery() }}
                    placeholder="Search Phase Template"
                    fullWidth
                    className={classes.searchInput}
                />
            </div>

        )
    };

    render = () => {
        return (
            this.renderSearchBar()
        );
    }

}

// @ts-ignore
export default withStyles(searchBarStyle)(SearchBar);